import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import FontKeys from '../FontKeys';
import AnalogClock from '../game/AnalogClock';
import DigitalClock from '../game/DigitalClock';
import StateButton from '../game/StateButton';
import gameData, { DEFAULT_BUTTON_CONFIG } from '../gameData';
import SoundAssetKeys from '../SoundAssetKeys';
import { playJingle, stopJingle } from '../SoundManager';
import UIAssetKeys from '../UIAssetKeys';
import SelectLevelScreen from './SelectLevelScreen';
import HelpPage from '../game/HelpPage';

export default class PracticeScreen extends Phaser.Scene {
  static get KEY() { return 'PracticeScreen'; }

  constructor() {
    super({ key: PracticeScreen.KEY });
  }

  init() {
    this.cheat = false;
  }

  create() {
    if (gameData.MUSIC_ON === true) {
      playJingle(SoundAssetKeys._title_theme);
    }

    this.backgroundImage = ABCyaPhaser.Images.addImage(0,0,UIAssetKeys._background_level0, this).setOrigin(0);
    this.backgroundImage.alpha = 0.9;

    this.analogClock = new AnalogClock(this);
    this.analogClock.x = this.scale.width / 2 - 270;
    this.analogClock.y = this.scale.height / 2 - 50;
    this.add.existing(this.analogClock);

    this.digitalClock = new DigitalClock(this);
    this.digitalClock.x = this.scale.width / 2 + 230;
    this.digitalClock.y = this.scale.height / 2 - 50;
    this.add.existing(this.digitalClock);

    this.analogClock.on('CHANGED', this.changeDigitalTime, this);

    this.digitalClock.on('CHANGED', this.changeAnalogTime,this);

    this.nextButton = ABCyaPhaser.Buttons.addDefaultButton(this.scale.width - 170, this.scale.height - 165, UIAssetKeys._next_button, null, SoundAssetKeys._click, this.transitionOut.bind(this), this, { ...DEFAULT_BUTTON_CONFIG });

    this.infoButton = ABCyaPhaser.Buttons.addDefaultButton(this.scale.width - 170, this.scale.height - 60, UIAssetKeys._info_button, null, SoundAssetKeys._click, this.showHelpPage.bind(this), this, { ...DEFAULT_BUTTON_CONFIG });

    // make toggle button for music
    this.musicButton = new StateButton(this, UIAssetKeys._speaker_on, UIAssetKeys._speaker_off);
    this.musicButton.x = this.scale.width - 70;
    this.musicButton.y = this.scale.height - 60;
    this.add.existing(this.musicButton);
    this.musicButton.doAction1 = this.speakerOff.bind(this);
    this.musicButton.doAction2 = this.speakerOn.bind(this);

    if (gameData.MUSIC_ON === false) {
      this.musicButton.switchStateOff();
    }

    const text = ABCyaPhaser.Text.addText(this.scale.width / 2 - 110, this.scale.height - 180, '36pt', 0xffffff, FontKeys._dimboregular,ABCyaPhaser.Localization.instance.getLocalizedString('practice_screen.instructions'),this, true).setOrigin(0.5, 0)
      .setShadow(5,5,'#000000', 10)
      .setLineSpacing(6)
      .setPadding(25)
      .setWordWrapWidth(700);

    this.cameras.main.zoom = 0;
    this.transitionIn();
  }

  transitionIn () {
    const totalRotation = 2 * 360;
    this.tweens.add({ targets: { value: 0 },
      duration: 700,
      ease: Phaser.Math.Easing.Linear,
      props: { value: 1 },
      onUpdate: (tween, target) => {
        this.cameras.main.setAngle(target.value * totalRotation);
      } });
    ABCyaPhaser.Tweens.addTween(this.cameras.main,700, { zoom: 1 }, Phaser.Math.Easing.Linear);
  }

  transitionOut () {
    ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._transition, this);

    const totalRotation = -2 * 360;
    this.tweens.add({ targets: { value: 0 },
      duration: 700,
      ease: Phaser.Math.Easing.Linear,
      props: { value: 1 },
      onUpdate: (tween, target) => {
        this.cameras.main.setAngle(target.value * totalRotation);
      } });
    ABCyaPhaser.Tweens.addTween(this.cameras.main,700, { zoom: 0 }, Phaser.Math.Easing.Linear, () => this.cleanUp());
  }

  cleanUp () {
    this.tweens.killAll();
    this.time.clearPendingEvents();
    this.time.removeAllEvents();

    this.scene.start(SelectLevelScreen.KEY);
  }

  showHelpPage () {
    this.helpPage = new HelpPage(this);
    this.add.existing(this.helpPage);

    this.helpPage.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, this.closeHelpPage,this);
  }

  closeHelpPage () {
    this.helpPage.destroy();
  }

  changeDigitalTime () {
    const hourMinuteArray = this.analogClock.getHoursAndMinutes();

    const clockHour = hourMinuteArray[0];
    const clockMinute = hourMinuteArray[1];
    const timeOfDay = hourMinuteArray[2];

    this.digitalClock.setHoursAndMinutes(clockHour, clockMinute, timeOfDay);
  }

  changeAnalogTime () {
    const hourMinuteArray = this.digitalClock.getHoursAndMinutes();

    const clockHour = hourMinuteArray[0];
    const clockMinute = hourMinuteArray[1];
    const timeOfDay = hourMinuteArray[2];

    this.analogClock.setHoursAndMinutes(clockHour, clockMinute, timeOfDay);
  }

  speakerOff () {
    gameData.MUSIC_ON = false;
    stopJingle();
  }

  speakerOn () {
    gameData.MUSIC_ON = true;
    playJingle(SoundAssetKeys._title_theme);
  }
}